"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Label_1 = __importDefault(require("../Label"));

var Styled_1 = require("./Styled");
/**
 * Field component wraps the input with a label,
 * and manages validations messages
 *
 * Some props are shared, such as:
 * * isDirty property
 * @version 1.0.0
 */


var Field =
/** @class */
function (_super) {
  __extends(Field, _super);

  function Field() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Field.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        name = _a.name,
        isDirty = _a.isDirty,
        message = _a.message,
        _b = _a.tight,
        tight = _b === void 0 ? false : _b,
        action = _a.action,
        children = _a.children,
        _c = _a.margin,
        margin = _c === void 0 ? false : _c;
    var newProps = tight ? {
      isDirty: isDirty,
      placeholder: label,
      tight: tight
    } : {
      isDirty: isDirty
    }; // @ts-ignore

    var formInput = react_1.default.cloneElement(children, newProps);
    return react_1.default.createElement(Styled_1.StyledField, {
      margin: margin
    }, tight ? formInput : react_1.default.createElement(Label_1.default, {
      label: label || '',
      name: name,
      action: action
    }, formInput), message && react_1.default.createElement(Styled_1.Message, {
      isDirty: isDirty
    }, message));
  };

  return Field;
}(react_1.default.PureComponent);

exports.default = Field;